import React from 'react';
import ReactDOM from 'react-dom';
import frameComponentsMap from '../frameRenderer/FramesMap.js';
// CSS
import "react-simple-flex-grid/lib/main.css";
import '../styles/global.css'

const frameEl   = document.getElementById('frameRenderer-' + pageframeIdentifier);
const frameName = frameEl.dataset.frame || 'NotFound';
const frameData = (fd_data && fd_data[frameName]) || {};
const fileName = frameName.toLowerCase().replace(' ', '');
const Frame = frameComponentsMap[fileName];

const FrameRenderer = () => {
    return (
        <div className="frame-renderer-container">
            <Frame frameInfo={frameData} namedstrings={namedstrings}/>
        </div>

    );
}
ReactDOM.render(
    <FrameRenderer />,
    frameEl
);

